export default __webpack_public_path__ + "static/media/TC02-white.54b84949.svg";